import "@rmlibrary/canvas-player-controls";

import { buildTranscriptHTML, getDevicePixelRatio, getLanguage, sanitiseDescriptions } from "./utilities";

import $ from "jquery";
import CanvasPlayer from "@rmlibrary/canvas-player";
import Formatter from "@rmlibrary/formatting";
import { generatePDF } from "./pdf";
import { loadAnimations } from "./animation";
import { pacStorage } from "./main";
import { retrieveFromStorage } from "./utilities";
import { storePrintValues } from "./logic/pac-video-storage";

const cjs = createjs;
const formatter = new Formatter();

// References to elements in the document.
const controls = document.getElementById("controls");

// Browser information.
const devicePixelRatio = getDevicePixelRatio();

// Player variables.
let stageVars = {};
let player = null;

// Video constants.
const language = getLanguage();
const animationNameFirstFlow = `investments_pac_video${language === "en" ? "" : "_fr"}`;
const animationNameSecondFlow = `investments_pac_video_flow2${language === "en" ? "" : "_fr"}`;
const printFilename = language === "en" ? "pac-video" : "pac-video";

// video pdf report button setup
const pdfReportButton = $("#pdf-results");
const pdfVideo = document.getElementById("pdf-report-video");
pdfReportButton.on("click", () => {
    const inputValues = retrieveFromStorage("pacvideo");
    const format = language === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";
    const date = formatter.formatDate(new Date(), format);

    $("#pdf-pac-video-date").text(date);
    $("#pdf-pac-video-name").text(inputValues.name);

    $(".graph-one").attr(
        "alt",
        language === "en"
            ? `Investing ${formatter.formatCurrency(inputValues.contributionAmounts.monthly)} a month graph`
            : `Graphe de cotisation mensuelle de ${formatter
                  .formatCurrency(inputValues.contributionAmounts.monthly)
                  .replace(/\s/g, " ")}`
    );
    $(".graph-two").attr(
        "alt",
        language === "en"
            ? `Investing ${formatter.formatCurrency(inputValues.contributionAmounts.biWeekly, decimals)}
               every two weeks graph`
            : `Graphe de cotisation aux deux semaines de ${formatter
                  .formatCurrency(inputValues.contributionAmounts.biWeekly, decimals)
                  .replace(/\s/g, " ")}`
    );
    $(".graph-three").attr(
        "alt",
        language === "en"
            ? `Add ${formatter.formatPercentage(
                  inputValues.annualPercentageIncrease
              )} extra every year (investing ${formatter.formatCurrency(
                  inputValues.contributionAmounts.biWeekly,
                  decimals
              )} every two weeks) graph`
            : `Graphe montant des cotisations gonflé de ${formatter
                  .formatPercentage(inputValues.annualPercentageIncrease)
                  .replace(/\s/g, " ")} (cotisations aux deux semaines de ${formatter
                  .formatCurrency(inputValues.contributionAmounts.biWeekly, decimals)
                  .replace(/\s/g, " ")})`
    );

    // monthly contributions without increase
    $(".pdf-pac-video-monthly-contributions-no-increase-10years").text(
        formatter.formatCurrency(inputValues.monthlyContributions.withoutIncrease.tenYears)
    );
    $(".pdf-pac-video-monthly-contributions-no-increase-20years").text(
        formatter.formatCurrency(inputValues.monthlyContributions.withoutIncrease.twentyYears)
    );
    $(".pdf-pac-video-monthly-contributions-no-increase-30years").text(
        formatter.formatCurrency(inputValues.monthlyContributions.withoutIncrease.thirtyYears)
    );

    // bi-weekly contributions wtihout increase
    $(".pdf-pac-video-bi-weekly-contributions-no-increase-10years").text(
        formatter.formatCurrency(inputValues.biWeeklyContributions.withoutIncrease.tenYears)
    );
    $(".pdf-pac-video-bi-weekly-contributions-no-increase-20years").text(
        formatter.formatCurrency(inputValues.biWeeklyContributions.withoutIncrease.twentyYears)
    );
    $(".pdf-pac-video-bi-weekly-contributions-no-increase-30years").text(
        formatter.formatCurrency(inputValues.biWeeklyContributions.withoutIncrease.thirtyYears)
    );

    // bi-weekly contributions with increase
    $(".pdf-pac-video-bi-weekly-contributions-increase-10years").text(
        formatter.formatCurrency(inputValues.biWeeklyContributions.withIncrease.tenYears)
    );
    $(".pdf-pac-video-bi-weekly-contributions-increase-20years").text(
        formatter.formatCurrency(inputValues.biWeeklyContributions.withIncrease.twentyYears)
    );
    $(".pdf-pac-video-bi-weekly-contributions-increase-30years").text(
        formatter.formatCurrency(inputValues.biWeeklyContributions.withIncrease.thirtyYears)
    );

    $(".pdf-pac-video-contribution-amounts-monthly").text(
        formatter.formatCurrency(inputValues.contributionAmounts.monthly)
    );
    const decimals = inputValues.contributionAmounts.biWeekly % 1 !== 0 ? 2 : 0;
    $(".pdf-pac-video-contribution-amounts-bi-weekly").text(
        formatter.formatCurrency(inputValues.contributionAmounts.biWeekly, decimals)
    );
    $(".pdf-pac-video-annual-percentage-increase").text(
        formatter.formatPercentage(inputValues.annualPercentageIncrease)
    );
    $(".starting-amount").text(formatter.formatCurrency(inputValues.startingAmount));

    generatePDF(pdfVideo);
});

function mc_symbol_clone() {
    var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
}

function initCanvasPlayer(autoplay, animation) {
    const library = animation.composition.getLibrary();
    const rootName = animation.meta.TITLE;
    animation.captionSwitch = () => isCaptionsOn;

    // library.properties.manifest.forEach(
    //     (asset) => (asset.src = `./animate/pac_video${language === "fr" ? "-fr" : ""}/${asset.src}`)
    // );

    function getFrame(clip, label) {
        if (!isNaN(label)) return Number(label);
        const labelObj = clip.labels.filter((l) => l.label === label)[0];
        if (!labelObj) return -1;
        return labelObj.position;
    }

    function barFactory(barHeight, barValue, barColor, barStartFrame, barEndFrame) {
        return function Bar(mode, startPosition, loop) {
            if (loop == null) {
                loop = false;
            }

            this.startFrame = -1;
            this.endFrame = -1;

            this.initialize(mode, startPosition, loop, {});

            var monthly10Years = new createjs.Graphics()
                .beginFill(barColor)
                .drawRoundRect(0, -barHeight, 200, barHeight, 10);
            var shape = new createjs.Shape(monthly10Years);
            var shapeOuter = new createjs.MovieClip();
            shapeOuter.x = -100;
            shapeOuter.addChild(shape);

            var label = new library.value10();
            label.parent = this;
            label.field.text = barValue;

            if (
                pacStorage.results.monthlyContributions.withoutIncrease.tenYears > 999999 ||
                pacStorage.results.monthlyContributions.withoutIncrease.twentyYears > 999999 ||
                pacStorage.results.monthlyContributions.withoutIncrease.thirtyYears > 999999 ||
                pacStorage.results.biWeeklyContributions.withoutIncrease.tenYears > 999999 ||
                pacStorage.results.biWeeklyContributions.withoutIncrease.twentyYears > 999999 ||
                pacStorage.results.biWeeklyContributions.withoutIncrease.thirtyYears > 999999 ||
                pacStorage.results.biWeeklyContributions.withIncrease.tenYears > 999999 ||
                pacStorage.results.biWeeklyContributions.withIncrease.twentyYears > 999999 ||
                pacStorage.results.biWeeklyContributions.withIncrease.thirtyYears > 999999
            ) {
                label.field.font = "bold 37px 'Roobert'";
            }
            if (
                pacStorage.results.monthlyContributions.withoutIncrease.tenYears > 9999999 ||
                pacStorage.results.monthlyContributions.withoutIncrease.twentyYears > 9999999 ||
                pacStorage.results.monthlyContributions.withoutIncrease.thirtyYears > 9999999 ||
                pacStorage.results.biWeeklyContributions.withoutIncrease.tenYears > 9999999 ||
                pacStorage.results.biWeeklyContributions.withoutIncrease.twentyYears > 9999999 ||
                pacStorage.results.biWeeklyContributions.withoutIncrease.thirtyYears > 9999999 ||
                pacStorage.results.biWeeklyContributions.withIncrease.tenYears > 9999999 ||
                pacStorage.results.biWeeklyContributions.withIncrease.twentyYears > 9999999 ||
                pacStorage.results.biWeeklyContributions.withIncrease.thirtyYears > 9999999
            ) {
                label.field.font = "bold 33px 'Roobert'";
            }
            label.setTransform(0, 0, 0.05, 0.05);
            label.alpha = 0;
            label._off = true;

            const setupBarAnimation = (startFrame, endFrame) => {
                const duration = endFrame - startFrame;

                this.timeline.addTween(
                    createjs.Tween.get(shapeOuter)
                        .to({ scaleY: 0 }, 0)
                        .to({ scaleY: 1 }, 9)
                        .wait(duration - 18)
                        .to({ scaleY: 0 }, 9)
                );

                this.timeline.addTween(
                    cjs.Tween.get(label)
                        .wait(9)
                        .to({ _off: false }, 0)
                        .to({ scaleX: 1.1, scaleY: 1.1, alpha: 1 }, 8)
                        .to({ scaleX: 1, scaleY: 1 }, 8, cjs.Ease.quadInOut)
                        .wait(duration - 50)
                        .to({ scaleX: 1.1, scaleY: 1.1 }, 8)
                        .to({ scaleX: 0, scaleY: 0, alpha: 0 }, 8)
                        .wait(9)
                );
            };

            this.on(
                "added",
                function () {
                    this.startFrame = getFrame(this.parent, barStartFrame);
                    this.endFrame = getFrame(this.parent, barEndFrame);

                    const duration = this.endFrame - this.startFrame;
                    if (this.startFrame > -1 && this.endFrame > -1) {
                        setupBarAnimation(this.startFrame, this.endFrame);

                        const old_draw = this.draw;
                        this.draw = function () {
                            let position = this.parent.currentFrame - this.startFrame;
                            const maxPosition = duration - 1;
                            if (position > maxPosition) position = maxPosition;
                            if (this.currentFrame !== position) {
                                this._updateTimeline(position, false);
                            }
                            return old_draw.apply(this, arguments);
                        };
                    }

                    shape.y = 0;
                    label.y = -barHeight - 40;
                },
                null,
                true
            );
        };
    }

    function calcBarHeight(savingsValue) {
        const maxHeight = pacStorage.results.biWeeklyContributions.withIncrease.thirtyYears;
        let barHeight = (savingsValue / maxHeight) * 600;
        return barHeight;
    }

    (library.bar10 = barFactory(
        calcBarHeight(pacStorage.results.monthlyContributions.withoutIncrease.tenYears),
        formatter.formatCurrency(pacStorage.results.monthlyContributions.withoutIncrease.tenYears),
        "#016DFF",
        "bar10start",
        "bar10end"
    )).prototype = getMCSymbolPrototype(library.bar10, null, null);

    (library.bar20 = barFactory(
        calcBarHeight(pacStorage.results.monthlyContributions.withoutIncrease.twentyYears),
        formatter.formatCurrency(pacStorage.results.monthlyContributions.withoutIncrease.twentyYears),
        "#016DFF",
        "bar20start",
        "bar20end"
    )).prototype = getMCSymbolPrototype(library.bar20, null, null);

    (library.bar30 = barFactory(
        calcBarHeight(pacStorage.results.monthlyContributions.withoutIncrease.thirtyYears),
        formatter.formatCurrency(pacStorage.results.monthlyContributions.withoutIncrease.thirtyYears),
        "#016DFF",
        "bar30start",
        "bar30end"
    )).prototype = getMCSymbolPrototype(library.bar30, null, null);

    (library.bar102wk = barFactory(
        calcBarHeight(pacStorage.results.biWeeklyContributions.withoutIncrease.tenYears),
        formatter.formatCurrency(pacStorage.results.biWeeklyContributions.withoutIncrease.tenYears),
        "#1E3784",
        "bar102wkstart",
        "bar102wkend"
    )).prototype = getMCSymbolPrototype(library.bar102wk, null, null);

    (library.bar202wk = barFactory(
        calcBarHeight(pacStorage.results.biWeeklyContributions.withoutIncrease.twentyYears),
        formatter.formatCurrency(pacStorage.results.biWeeklyContributions.withoutIncrease.twentyYears),
        "#1E3784",
        "bar202wkstart",
        "bar202wkend"
    )).prototype = getMCSymbolPrototype(library.bar202wk, null, null);

    (library.bar302wk = barFactory(
        calcBarHeight(pacStorage.results.biWeeklyContributions.withoutIncrease.thirtyYears),
        formatter.formatCurrency(pacStorage.results.biWeeklyContributions.withoutIncrease.thirtyYears),
        "#1E3784",
        "bar302wkstart",
        "bar302wkend"
    )).prototype = getMCSymbolPrototype(library.bar302wk, null, null);

    (library.bar10percent = barFactory(
        calcBarHeight(pacStorage.results.monthlyContributions.withIncrease.tenYears),
        formatter.formatCurrency(pacStorage.results.monthlyContributions.withIncrease.tenYears),
        "#839FEC",
        "bar10percentstart",
        "bar10percentend"
    )).prototype = getMCSymbolPrototype(library.bar10percent, null, null);

    (library.bar20percent = barFactory(
        calcBarHeight(pacStorage.results.monthlyContributions.withIncrease.twentyYears),
        formatter.formatCurrency(pacStorage.results.monthlyContributions.withIncrease.twentyYears),
        "#839FEC",
        "bar20percentstart",
        "bar20percentend"
    )).prototype = getMCSymbolPrototype(library.bar20percent, null, null);

    (library.bar30percent = barFactory(
        calcBarHeight(pacStorage.results.monthlyContributions.withIncrease.thirtyYears),
        formatter.formatCurrency(pacStorage.results.monthlyContributions.withIncrease.thirtyYears),
        "#839FEC",
        "bar30percentstart",
        "bar30percentend"
    )).prototype = getMCSymbolPrototype(library.bar30percent, null, null);

    (library.bar10percent2wk = barFactory(
        calcBarHeight(pacStorage.results.biWeeklyContributions.withIncrease.tenYears),
        formatter.formatCurrency(pacStorage.results.biWeeklyContributions.withIncrease.tenYears),
        "#00BD74",
        "bar10percent2wkstart",
        "bar10percent2wkend"
    )).prototype = getMCSymbolPrototype(library.bar10percent2wk, null, null);

    (library.bar20percent2wk = barFactory(
        calcBarHeight(pacStorage.results.biWeeklyContributions.withIncrease.twentyYears),
        formatter.formatCurrency(pacStorage.results.biWeeklyContributions.withIncrease.twentyYears),
        "#00BD74",
        "bar20percent2wkstart",
        "bar20percent2wkend"
    )).prototype = getMCSymbolPrototype(library.bar20percent2wk, null, null);

    (library.bar30percent2wk = barFactory(
        calcBarHeight(pacStorage.results.biWeeklyContributions.withIncrease.thirtyYears),
        formatter.formatCurrency(pacStorage.results.biWeeklyContributions.withIncrease.thirtyYears),
        "#00BD74",
        "bar30percent2wkstart",
        "bar30percent2wkend"
    )).prototype = getMCSymbolPrototype(library.bar30percent2wk, null, null);

    $("#print-results").on("click", () => window.open(`print/${printFilename}.html`));

    function showCTAButtons() {
        $(`.cp-overlay`).show();
        $(".pac-vid-btn").show().focus();
        resizeButtonText();
    }
    function hideCTAButtons() {
        $(`.cp-overlay`).hide();
        $(".pac-vid-btn").hide();
    }

    function getTextSize(text, opts) {
        var c, font, size, sizeDifference;

        opts.textBoxWidth = opts.textBoxWidth || 20;
        opts.defaultFontSize = opts.defaultFontSize || 67;
        opts.fontFamily = opts.fontFamily || "Roobert";
        opts.fontWeight = opts.fontWeight || "bold";
        opts.sizeDifference = opts.sizeDifference || 0;

        c = $("<canvas></canvas>")[0].getContext("2d");
        c.font = opts.fontWeight + " " + opts.defaultFontSize + "px " + opts.fontFamily;

        size = c.canvas.height;
        font = opts.fontWeight + " " + opts.defaultFontSize + "px '" + opts.fontFamily + "'";
        sizeDifference = opts.sizeDifference;

        return {
            size: size,
            font: font,
            sizeDifference: sizeDifference
        };
    }

    stageVars = {
        addPrintButton: function () {
            showCTAButtons();
        },
        addReplayButton: function () {
            showCTAButtons();
        },
        name: function () {
            return pacStorage.pacName;
        },
        nameSize: function () {
            let font = null;
            let sizeDifference = null;

            if (pacStorage.pacName.length < 10) {
                font = getTextSize(pacStorage.pacName, {
                    defaultFontSize: 51,
                    fontFamily: "Roobert",
                    fontWeight: "bold",
                    sizeDifference: -6
                }).font;
                sizeDifference = -6;
            } else if (pacStorage.pacName.length == 10) {
                font = getTextSize(pacStorage.pacName, {
                    defaultFontSize: 40,
                    fontFamily: "Roobert",
                    fontWeight: "bold",
                    sizeDifference: -5
                }).font;
                sizeDifference = -5;
            } else if (pacStorage.pacName.length >= 11 && pacStorage.pacName.length < 14) {
                font = getTextSize(pacStorage.pacName, {
                    defaultFontSize: 23,
                    fontFamily: "Roobert",
                    fontWeight: "bold",
                    sizeDifference: 3
                }).font;
                sizeDifference = 3;
            } else {
                font = getTextSize(pacStorage.pacName, {
                    defaultFontSize: 21,
                    fontFamily: "Roobert",
                    fontWeight: "bold",
                    sizeDifference: 3
                }).font;
                sizeDifference = 3;
            }

            return { font: font, sizeDifference: sizeDifference };
        },
        eggText: function () {
            return pacStorage.pacBiWeeklyDifference;
        },
        eggTextSize: function () {
            var eggValue =
                pacStorage.results.biWeeklyContributions.withIncrease.thirtyYears -
                pacStorage.results.monthlyContributions.withIncrease.thirtyYears;
            var font;
            if (eggValue.toString().length < 7) {
                font = "bold 50px 'Roobert'";
            } else if (eggValue.toString().length >= 7 && eggValue.toString().length < 8) {
                font = "bold 40px 'Roobert'";
            } else {
                font = "bold 35px 'Roobert'";
            }
            return font;
        },
        setUpTweens: function () {
            var monthly10Years = new createjs.Graphics().beginFill("red").drawRect(0, 0, 100, 100);
            var shape = new createjs.Shape(monthly10Years);
            this.stage.addChild(shape);
            this.timeline.addTween(createjs.Tween.get(shape).to({ scaleY: 2 }, 3000));
        },
        monthly10Years: "",
        year10Tween: "",
        timeline: new createjs.Timeline(),
        shrinkBar: function () {
            stageVars.timeline.removeTween(stageVars.year10Tween);
            this.stage.removeChild(stageVars.monthly10Years);
        },
        pacStorage: pacStorage,
        registerPrintButton: function (instance) {
            fixReset(instance);
        },
        registerReplayButton: function (instance) {
            fixReset(instance);
        }
    };

    if (player !== null && player !== undefined) {
        player.destroy();
    }

    player = new CanvasPlayer(document.querySelector(".cp-container"), animation, {
        autoplay,
        pixelDensity: 1,
        enableCC: true,
        rootName,
        stageVars
    });

    player.canvas.ariaLabel = language === "en" ? "PAC Video" : "Vidéo sur le PAC";


    player.on("resizeEnd", () => {
        setTimeout(() => {
            resizeButtonText();
        }, 250);
    });

    player.on("timeupdate", () => {
        if (!$(".rm-slider-handle").attr("aria-label")) {
            $(".rm-slider-handle").attr("aria-label", "video progress bar");
        }
        try {
            const printButtonStartFrame = player.exportRoot.labels.filter((l) => l.label === "printButtonStart")[0]
                .position;

            if (player.exportRoot.currentFrame > printButtonStartFrame) {
                showCTAButtons();
            } else {
                hideCTAButtons();
            }
        } catch (error) {
            // Do nothing
        }

        $(".cp-large-play").addClass("hide");
        $(".cp-large-replay").addClass("hide");
    });

    controls.toggleIndicators(true);
    controls.attachCanvasPlayer(player);

    function formatTranscript(text) {
        const {
            pacStartingAmount: initialInvestment,
            results: {
                monthlyContributions: {
                    withIncrease: {
                        tenYears: tenYearsMonthlyWithIncreaseSavings,
                        twentyYears: twentyYearsMonthlyWithIncreaseSavings,
                        thirtyYears: thirtyYearsMonthlyWithIncreaseSavings
                    },
                    withoutIncrease: {
                        tenYears: tenYearsMonthlySavings,
                        twentyYears: twentyYearsMonthlySavings,
                        thirtyYears: thirtyYearsMonthlySavings
                    }
                },
                biWeeklyContributions: {
                    withIncrease: {
                        tenYears: tenYearsBiWeeklyWithIncreaseSavings,
                        twentyYears: twentyYearsBiWeeklyWithIncreaseSavings,
                        thirtyYears: thirtyYearsBiWeeklyWithIncreaseSavings
                    },
                    withoutIncrease: {
                        tenYears: tenYearsBiWeeklySavings,
                        twentyYears: twentyYearsBiWeeklySavings,
                        thirtyYears: thirtyYearsBiWeeklySavings
                    }
                }
            }
        } = pacStorage;
        const pacDifference = thirtyYearsBiWeeklyWithIncreaseSavings - thirtyYearsMonthlyWithIncreaseSavings;
        const pacTotal = thirtyYearsBiWeeklyWithIncreaseSavings;
        let formattedText = "";

        if (text) {
            formattedText = text
                .replace(/\[initialInvestment\]/gi, `${initialInvestment}`)
                .replace(/\[tenYearsMonthlySavings\]/gi, `${formatter.formatCurrency(tenYearsMonthlySavings)}`)
                .replace(/\[tenYearsBiWeeklySavings\]/gi, `${formatter.formatCurrency(tenYearsBiWeeklySavings)}`)
                .replace(
                    /\[tenYearsMonthlyWithIncreaseSavings\]/gi,
                    `${formatter.formatCurrency(tenYearsMonthlyWithIncreaseSavings)}`
                )
                .replace(
                    /\[tenYearsBiWeeklyWithIncreaseSavings\]/gi,
                    `${formatter.formatCurrency(tenYearsBiWeeklyWithIncreaseSavings)}`
                )
                .replace(/\[twentyYearsMonthlySavings\]/gi, `${formatter.formatCurrency(twentyYearsMonthlySavings)}`)
                .replace(/\[twentyYearsBiWeeklySavings\]/gi, `${formatter.formatCurrency(twentyYearsBiWeeklySavings)}`)
                .replace(
                    /\[twentyYearsMonthlyWithIncreaseSavings\]/gi,
                    `${formatter.formatCurrency(twentyYearsMonthlyWithIncreaseSavings)}`
                )
                .replace(
                    /\[twentyYearsBiWeeklyWithIncreaseSavings\]/gi,
                    `${formatter.formatCurrency(twentyYearsBiWeeklyWithIncreaseSavings)}`
                )
                .replace(/\[thirtyYearsMonthlySavings\]/gi, `${formatter.formatCurrency(thirtyYearsMonthlySavings)}`)
                .replace(/\[thirtyYearsBiWeeklySavings\]/gi, `${formatter.formatCurrency(thirtyYearsBiWeeklySavings)}`)
                .replace(
                    /\[thirtyYearsMonthlyWithIncreaseSavings\]/gi,
                    `${formatter.formatCurrency(thirtyYearsMonthlyWithIncreaseSavings)}`
                )
                .replace(
                    /\[thirtyYearsBiWeeklyWithIncreaseSavings\]/gi,
                    `${formatter.formatCurrency(thirtyYearsBiWeeklyWithIncreaseSavings)}`
                )
                .replace(/\[pacDifference\]/gi, `${formatter.formatCurrency(pacDifference)}`)
                .replace(/\[pacTotal\]/gi, `${formatter.formatCurrency(pacTotal)}`);
        }

        return formattedText;
    }

    player.on("canplay", () => {
        let descriptions = player.generateTranscript();
        descriptions = sanitiseDescriptions(descriptions);
        descriptions = descriptions.map((description) => formatTranscript(description));

        controls.updateTranscript(buildTranscriptHTML(descriptions), "#transcript-body", "transcript.html");
    });

    $("#replay-video").on("click", () => {
        player.goToFrame(0);
        player.play();
        $(".cp-play").addClass("hide");
        $(".cp-replay").addClass("hide");
        $(".cp-pause").removeClass("hide");
    });
}

// Used to resize the text for the cta buttons at the end of the video
function resizeButtonText() {
    const width = $("#print-results").outerWidth();
    const ratio = language === "en" ? 0.11857687132347254 : 0.07407407407407407;

    $(".pac-vid-btn").css("font-size", width * ratio);
}

function updatePrintValues() {
    const {
        pacAnnualPercentageIncrease: annualPercentageIncrease,
        pacMonthlyAmount: contributionAmount,
        pacName: name,
        pacStartingAmount: startingAmount,
        results: { biWeeklyContributions, monthlyContributions }
    } = pacStorage;

    storePrintValues({
        annualPercentageIncrease,
        biWeeklyContributions,
        contributionAmount,
        monthlyContributions,
        name,
        startingAmount
    });
}

function initPlayer(autoplay) {
    const language = getLanguage();
    const startingAmount = Number(pacStorage.pacStartingAmount.replace(/[^\d]/g, ""));
    const animationName = startingAmount > 0 ? [animationNameFirstFlow] : [animationNameSecondFlow];

    updatePrintValues();
    $(".cp-preloader").removeClass("hide");
    loadAnimations(language, animationName, "animate/pac_video").then((animation) =>
        initCanvasPlayer(autoplay, animation[0])
    );
}

function fixReset(instance) {
    if (!instance._reset_fixed) {
        var old_reset = instance._reset;
        instance._reset = function () {
            old_reset.call(this);
            this.paused = true;
        };
        instance._reset_fixed = true;
    }
}

export { initPlayer };
